import { useLang } from '@/i18n';
import css from './index.module.scss';
import { useState, useEffect } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import gtm from '@/utils/gtm';
import getLocal from '@/app/utils/i18n';

interface ItemType {
    tab: string;
    name: string;
    text: string;
    btn?: string;
    img: string[];
    webp?: string[];
}
const H: React.FC = () => {
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const { locale } = getLocal();
    const [active, setActive] = useState(0);
    const [enter, setEnter] = useState(false);
    const items: ItemType[] = [
        {
            tab: t('H_item1_tab'),
            name: t.rich('H_item1_name', {
                s: (v: string) => <span className="s">{v}</span>,
            }),
            text: t('H_item1_text'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1773197551988/1-pc-1.jpg', 'https://websiteoss.ecoflow.com/upload/image/1773197551394/1-m-1.jpg'],
        },
        {
            tab: t('H_item2_tab'),
            name: t.rich('H_item2_name', {
                s: (v: string) => <span className="s">{v}</span>,
            }),
            text: t('H_item2_text'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1773197552201/1-pc-2.jpg', 'https://websiteoss.ecoflow.com/upload/image/1773197551562/1-m-2.jpg'],

        },
        {
            tab: t('H_item3_tab'),
            name: t.rich('H_item3_name', {
                s: (v: string) => <span className="s">{v}</span>,
            }),
            text: t('H_item3_text'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1773197552427/1-pc-3.jpg', 'https://websiteoss.ecoflow.com/upload/image/1773197551799/1-m-3.jpg'],

        },
    ];

    const handleChangeTab = (e: any, k: number) => {
        setActive(k);
        if (window.innerWidth < 1024) {
            e.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: t('H_title'),
            button_name: items[k].tab,
            __btn_id1: `dpu-H .tab-${k}`,
            __btn_id2: items[k].tab,
            __btn_type: 'text',
        });
    };



    useEffect(() => {
        if (typeof window !== 'undefined') {
            const sceneHArr: any[] = [];
            const title: HTMLElement | null = document.querySelector('#delta-pro-ultra-H .title');
            if (title) {
                sceneHArr.push(
                    AniContainer.create({
                        triggerElement: '#delta-pro-ultra-H .info',
                        triggerHook: 1,
                        offset: title?.offsetHeight + 120,
                        duration: '100%',
                        onEnter: () => setEnter(true),
                        onProcess: (process: number) => {
                            if (process <= 0) {
                                setEnter(false);
                            }
                        },
                    }),
                );
            }
            return () => {
                sceneHArr.forEach((item) => {
                    item.destroy();
                });
            };
        }
    }, []);

    return (
        <section
            className={`${css.section} delta-pro-ultra-H dpu-H GtmModuleData-section active-box-${active + 1}`}
            id="delta-pro-ultra-H"
            data-section-id={'delta-pro-ultra-H'}
            data-section-title={t('H_title')}
        >
            <div className={``}>
                <ul className="imgs">
                    {items.map((item: ItemType, k: number) => (
                        <li className={`img${k === active ? ' active' : ''}`} key={item.tab}>
                            <EcoImg pc={item.img[0]} h5={item.img[1]} isOpenLazy />
                        </li>
                    ))}
                </ul>
                <div className={`box active-${active + 1}`}>
                    <div className="info">
                        <p className={`title${enter ? ' enter' : ''}`}>{t('H_title')}</p>
                    </div>
                    <div className="inner">
                        <ul className="tabs">
                            {items.map((item: ItemType, k: number) => (
                                <li
                                    className={`tab${k === active ? ' active' : ''} tab-${k} GtmModuleData-btn-text`}
                                    key={item.tab}
                                    onClick={(e) => handleChangeTab(e, k)}
                                >
                                    {item.tab}
                                </li>
                            ))}
                        </ul>
                        <ul className="contents">
                            {items.map((item: ItemType, k: number) => (
                                <li className={`content${k === active ? ' active' : ''}`} key={item.tab}>
                                    <p className="content-name">{item.name}</p>
                                    {/* <p className="content-text">{item.text}</p> */}

                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default H;
